var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("rect",{"width":"64","height":"64","rx":"4"})),React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#fff","stroke":"#1B68FF","strokeWidth":"12","mask":"url(#a)","key":1}),React.createElement("path",{"d":"M22.75 12h17.5A3.75 3.75 0 0144 15.75v32.5A3.75 3.75 0 0140.25 52h-17.5A3.75 3.75 0 0119 48.25v-32.5A3.75 3.75 0 0122.75 12zm8.75 37.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-8.75-8.44c0 .52.42.94.94.94H39.3c.52 0 .94-.42.94-.94V16.7a.94.94 0 00-.94-.94H23.7a.94.94 0 00-.94.94v24.37z","fill":"#1B68FF","key":2})]);
}

Mobile.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = Mobile;

Mobile.default = Mobile;
